import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";

type Config = {
    offerIds?: string[];
};

export const useGetOffers = ({ offerIds }: Config) => {
    const { getMultiple } = useMicrocopy();

    if (!offerIds) return [];

    const mappedMicrocopies = offerIds?.reduce((acc, id) => {
        acc.push(`${id}.disclaimer`, `${id}.description`);
        return acc;
    }, []);

    const microcopies = getMultiple(CommonCMS.offers, mappedMicrocopies);

    return offerIds
        .filter((id) => microcopies[`${id}.description`] || microcopies[`${id}.disclaimer`])
        .map((id) => ({
            description: microcopies[`${id}.description`],
            disclaimer: microcopies[`${id}.disclaimer`],
        }));
};
